module.exports = __webpack_public_path__ + "img/section_bg_4.e3b56ec6.png";